import { combineReducers } from 'redux';
import metadataReducer from './metadata';
import seoReducer from './seo';
import groupMetadataReducer from './groupMetaData';
import listingPackagesReducer from './listingPackages';
import listinSectionsReducer from './sections';
import searchReducer from './searchReducer';
import subMenuReducer from './subMenuReducer';
import coachmarkReducer from '../../../common/component/Coachmark/redux/coachmarkReducer';
import notificationsReducer from './notificationsReducer';

const reducer = combineReducers({
  metadata: metadataReducer,
  seo: seoReducer,
  groupMetadata: groupMetadataReducer,
  listingPackages: listingPackagesReducer,
  sections: listinSectionsReducer,
  search: searchReducer,
  subMenu: subMenuReducer,
  coachmark: coachmarkReducer,
  notificationsReducer,
});

export default reducer;
